// Theme Colors
// Initially this will be blank. Later on when app is initialized we will assign bootstrap colors to this from CSS variables.
export const $themeColors = {}

// App Breakpoints
// Initially this will be blank. Later on when app is initialized we will assign bootstrap breakpoints to this object from CSS variables.
export const $themeBreakpoints = {}

// APP CONFIG
export const $themeConfig = {
  app: {
    appName: 'Admin', // Will update name in navigation menu (Branding)
    appRef:'zip',
    // eslint-disable-next-line global-require
    appLogoImage: require('@/assets/images/logo/DNA-logo.png'), // Will update logo in navigation menu (Branding)
  },
  layout: {
    isRTL: false,
    skin: 'light', // light, dark, bordered, semi-dark
    routerTransition: 'zoom-fade', // zoom-fade, slide-fade, fade-bottom, fade, zoom-out, none
    type: 'vertical', // vertical, horizontal
    contentWidth: 'full', // full, boxed
    menu: {
      hidden: false,
      isCollapsed: false,
    },
    navbar: {
      // ? For horizontal menu, navbar type will work for navMenu type
      type: 'floating', // static , sticky , floating, hidden
      backgroundColor: '', // BS color options [primary, success, etc]
    },
    footer: {
      type: 'static', // static, sticky, hidden
    },
    customizer: true,
    enableScrollToTop: true,
  },
  snowOption: {
    theme: "snow",
    modules: {
      toolbar: [
        {
          'header':[]
        },  
        { 
          'size': ['6px', '8px', '10px', '12px', '14px', '16px', '18px', '20px', '24px', '30px', '32px', '36px'] 
        },
        'bold', 
        'italic', 
        'underline', 
        'strike', 
        { 
          'color': ['#515353', '#062F87', '#0074C8', '#FFFFFF', '#000000', '#BFBFBF', '#666767', '#789D10', '#1B5633', '#CF152D', '#BA0261', '#FF0586', '#FF65A5', '#FFCC33', '#FFFF99', '#FFDF99', '#01D5FF','#7B4303','#9C1D75','#0047B2','#07154E'] 
        },
        { 
          'align': [] 
        }, 
        'link', 
        'clean' 
      ]
    }
  },
}
